<template>
  <div class="document-container">
    <div class="columns">
      <div class="column column-left is-three-quarters is-paddingless">
        <div class="flex-container-left">
          <div>
            <div class="document-container">
              <div class="document">
                <div class="header">
                  <es-header>
                    <template #header>
                      <div class="header-title">Customize Report: All Locations</div>
                    </template>
                  </es-header>
                </div>
                <div class="content">
                  <es-form>
                    <template #es-form-header>
                      <div class="header-container">
                        <div class="header-elements">
                          <font-awesome-icon :icon="['fas', 'filter']" size="lg" />
                        </div>
                        <div class="header-elements">
                          <h6 class="title">
                            Filter Type
                          </h6>
                        </div>
                      </div>
                    </template>
                    <template #es-form>
                      <div class="field is-horizontal">
                      </div>
                      <div class="field is-horizontal">
                        <div class="field-label">
                          <label class="label">Status</label>
                        </div>
                        <div class="field-body">
                          <div class="field is-narrow">
                            <div class="control">
                              <label class="radio">
                                <input type="radio" v-model="status" value="ALL"
                                name="status">
                                All
                              </label>
                              <label class="radio">
                                <input type="radio" v-model="status" value="ACTIVE"
                                name="status">
                                Active
                              </label>
                              <label class="radio">
                                <input type="radio" v-model="status" value="INACTIVE"
                                name="status">
                                Inactive
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                        <div class="header-container">
                          <div class="header-elements">
                            <font-awesome-icon :icon="['fas', 'file-edit']" size="lg" />
                          </div>
                          <div class="header-elements">
                            <h6 class="title">
                              Format
                            </h6>
                          </div>
                        </div>
                        <div class="field is-horizontal">
                        </div>
                        <div class="field is-horizontal">
                          <div class="field-label">
                            <label class="label">File Format</label>
                          </div>
                          <div class="field-body">
                            <div class="field is-narrow">
                              <div class="control">
                                <label>
                                  <input type="text" class="is-hidden" v-model="delim" value="COMMA"
                                  name="delim">
                                  <font-awesome-icon :icon="['fas', 'file-csv']" size="lg"
                                  class="text-green"/> CSV
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="field is-horizontal">
                        </div>
                        <div class="field is-horizontal">
                          <div class="field-label">
                            <label class="label">Qualifier</label>
                          </div>
                          <div class="field-body">
                            <div class="field is-narrow">
                              <div class="control">
                                <label class="radio">
                                  <input type="radio" v-model="qual" value="NONE"
                                  name="qual">
                                  None
                                </label>
                                <label class="radio">
                                  <input type="radio" v-model="qual" value="DOUBLE_QUOTES"
                                  name="qual">
                                  Double Quotes
                                </label>
                                <label class="radio">
                                  <input type="radio" v-model="qual" value="SINGLE_QUOTES"
                                  name="qual">
                                  Single Quotes
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                    </template>
                  </es-form>
                </div>
                <div class="es-actions">
                  <es-form-actions>
                    <template #form-actions>
                      <div class="bottom-content">
                        <ul>
                          <li class="reset">
                            <div class="list-content">
                              <a @click="$router.push(
                                { name: 'reportsmainl' }
                              )">
                                Cancel
                              </a>
                            </div>
                          </li>
                          <li>
                            <div class="list-content">
                              <button
                                class="button is-primary"
                                 @click="post"
                                >
                                  Generate
                              </button>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </template>
                  </es-form-actions>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column column-right is-one-quarter is-paddingless">
        <div class="flex-container-right">
          <div class="document-container">
            <div class="document" name="instructions">
              <div class="header">
                <es-header>
                  <template #header>
                    <div class="header-title">Instructions</div>
                  </template>
                </es-header>
              </div>
              <div class="activity-row">
                <div class="activity-row-container">
                  <div class="activity-summary">
                    <div class="activity-status activity-element">
                      <div>
                        <span class="has-text-grey">
                          This page allows you to customize the report by
                          making selections in Filter By and Format sections.
                        </span>
                      </div>
                      <div>
                        <span class="has-text-weight-bold">
                          Filter By
                        </span>
                      </div>
                      <div>
                        <span class="has-text-grey">
                          You may filter the report by selecting filter fields
                          available on the page.
                          Some fields are pre-selected as default.
                        </span>
                      </div>
                      <div>
                        <span class="has-text-weight-bold">
                          Format
                        </span>
                      </div>
                      <div>
                        <span class="has-text-grey">
                          You may select proper file format and qualifier for
                          downloaded file.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleRight,
  faTimes,
  faCheckCircle,
  faEdit,
  faEllipsisH,
  faFileCsv,
  faFileEdit,
  faFilter,
  faMapMarkerAlt,
  faNotEqual,
} from '@fortawesome/pro-light-svg-icons';
import {
  faFileCsv as faFileCsvSolid,
  faFileEdit as faFileEditSolid,
  faFilter as faFilterSolid,
} from '@fortawesome/pro-solid-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsHeader from '@/components/EsHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faAngleRight,
  faTimes,
  faCheckCircle,
  faEdit,
  faEllipsisH,
  faFileCsv,
  faFileCsvSolid,
  faFileEdit,
  faFileEditSolid,
  faFilter,
  faFilterSolid,
  faMapMarkerAlt,
  faNotEqual,
);

export default {
  mixins: [BreadcrumbsManager, NotificationManager],
  created() {
    this.setBreadcrumbs();
  },
  components: {
    EsForm,
    EsFormActions,
    EsHeader,
  },
  data() {
    return {
      status: 'ALL',
      reportType: 'ALL_LOCATIONS',
      delim: 'COMMA',
      qual: 'NONE',
      formErrorMsg: 'There were some errors. Please try again. If errors persist please contact support.',
    };
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
    }),
  },
  methods: {
    setBreadcrumbs() {
      this.setBreadcrumb([
        { text: 'Home', to: { name: 'groupList' } },
        { text: 'Reports', to: { name: 'reportsmainl' } },
        { text: 'All Locations Report', to: {} },
      ]);
    },
    resetForm() {
      this.status = 'ALL';
      this.delim = 'COMMA';
      this.qual = 'NONE';
    },
    async post() {
      console.log(this.$route.params.reportType);
      // Local Code || State Location Id
      try {
        const res = await axios.post('/reports/', ({
          status: this.status,
          delim: this.delim,
          qual: this.qual,
          reportType: this.reportType,
        }));
        this.$emit('reportCreated', res.data);
        this.$router.push('/locationID/reports');
      } catch (err) {
        console.error(err);
        this.messages.push(this.formErrorMsg);
        this.showNotification('danger', this.messages);
      }
    },
  },
};
</script>

  <style lang="sass" scoped>
    .text-muted
      color: #6c757d !important
    .activity-row
      border-top: 1px solid rgb(222, 226, 230)
    .activity-row-container
      padding: .5rem 1rem
      display: flex
    .icon-column
      min-width: 40px
      display: flex
      align-items: flex-start
    .activity-summary
      font-size: .85rem
      display: flex
      flex-direction: column
      align-items: flex-start
    .activity-element
      padding-top: 4px
      padding-bottom: 4px
      text-align: left
    .activity-status
      text-align: left
    .text-green
      color: #55a156
  </style>
